import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import blueLeftBackground from '../../img/v2/home/blueLeftBackground.png'
import blueRightBackground from '../../img/v2/home/blueRightBackground.png'

import "../../scss/v2/user/container.scss"

function SquareContainer(props) {

    const { i18n } = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(props.lang)
    }, [i18n, props.lang])

    return (
        <div className="user-square-container container">
            <div className="row">
                <div className="col-12 col-lg-8 offset-lg-2">
                    <div className="square-background">
                        <img className="img img-fluid left-square-background" src={blueLeftBackground} alt={blueLeftBackground} />
                        <div className="square-bakground-content">
                            {props.children}
                        </div>
                        <img className="img img-fluid right-square-background" src={blueRightBackground} alt={blueRightBackground} />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default SquareContainer